import type { ViewBox } from "types/documentation";

// TODO: Why 428x316? Document this choice.
export const BASE_VIEWBOX: ViewBox = { x: 0, y: 0, w: 428, h: 316 };
